class AnimatedHeroImage {
  constructor(section) {
    this.section = section;
    const media = section; 
    if (!media) return;

    this.el = media;
    this.startScale = 1; // Zoom in starting scale
    this.endScale = 1.1; // Maximum zoom out scale

    this.onScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.onScroll);
    this.onScroll();
  }

  onScroll() {
    const rect = this.section.getBoundingClientRect(); 
    const triggerHeight = rect.height * 0.9;
    // We reverse the calculation to make the zooming happen on the opposite direction
    const p = Math.min(Math.max(rect.top, 0), triggerHeight) / triggerHeight; // Adjust the formula

    const scale = this.startScale + (this.endScale - this.startScale) * p;

    this.el.style.transform = `scale(${scale})`;
  }
}

document.querySelectorAll('.article-images-zoom').forEach(section => {
  new AnimatedHeroImage(section);
});

